import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import RazorpayButton from "../../pages/RazorpayButton/RazorpayButton";

const Checkout = () => {
  const userId = "example-user-id"; // Replace with actual user ID
  const amount = 1; // Replace with actual amount

  return (
    <>
      <Container>
        <Row>
          <Col lg={12} className="text-center">
            <h2>Checkout Page</h2>
            <RazorpayButton amount={amount} userId={userId} />
          </Col>
        </Row>
      </Container>

    </>
  );
};

export default Checkout;


// import React from "react";
// import ApplyCoupon from "../components/ApplyCoupon";

// const CheckoutPage = () => {
//   const cartTotal = 1000; // Get from Redux or Context

//   return (
//     <div>
//       <h2>Checkout</h2>
//       <ApplyCoupon cartTotal={cartTotal} />
//       <button>Proceed to Payment</button>
//     </div>
//   );
// };

// export default CheckoutPage;
